import React, { useEffect, useState } from 'react'
import { useForm, FormProvider } from 'react-hook-form'
import { Grid, Box } from '@material-ui/core'
import { components } from 'cng-web-lib'
import { useParams } from 'react-router-dom'
import pathMap from 'src/paths/pathMap'
import ConfirmDialog from 'src/views/common/ConfirmDialog'
import MPCIApiUrls from '../Common/services/MPCIApiService'
import MpciApiClient from '../Common/services/MpciApiClient'
import UaeMpciApiUrls from 'src/apiUrls/UaeMpciApiUrls'
import FormProperties from './FormProperties'
import ParentCard from 'src/components/era-package/shared/ParentCard'
import SnackBar from 'src/components/era-package/era/SnackBar'

const {
  button: { CngButton }
} = components

function EditPage({ history, showNotification }) {
  const { id } = useParams()
  const [isFetching, setIsFetching] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const [showSuccess, setShowSuccess] = useState(false)
  const [showError, setShowError] = useState(null)

  const methods = useForm({
    defaultValues: { ...FormProperties.formikProps.initialValues }
  })

  useEffect(() => {
    MpciApiClient.getById(
      UaeMpciApiUrls.VESSEL_MASTER_GET,
      id,
      (record) => {
        if (!record) {
          showNotification('error', 'Data not found.')
          history.push(pathMap.UAE_MPCI_VESSEL_MASTER_LIST_VIEW)
        } else {
          methods.reset(FormProperties.toClientDataFormat(record))
        }
        setIsFetching(true)
      },
      () => {
        showNotification('error', 'Failed to load record.')
        history.push(pathMap.UAE_MPCI_VESSEL_MASTER_LIST_VIEW)
        setIsFetching(true)
      }
    )
  }, [])

  const onSubmit = methods.handleSubmit((formValues) => {
    setSubmitting(true)
    const payload = FormProperties.toServerDataFormat(formValues)
        MpciApiClient.put(
      `${MPCIApiUrls.VESSEL_MASTER.PUT}/${id}`,
      payload,
      () => {
        setSubmitting(false)
        setShowSuccess(true)
      },
      (err) => {
        setSubmitting(false)
        const errMsg = (err && err.status && err.message && err.status !== 500) ? `Error: ${err.status} - ${err.message}` : 'Failed to update Vessel. Please try again.'
        setShowError(errMsg)
      }
    )
  })

  if (!isFetching) return <p>Loading...</p>

  return (
    <ParentCard title='Edit Vessel'>
      <FormProvider {...methods}>
        <form onSubmit={onSubmit}>
          <FormProperties.Fields
            disabled={false}
            showNotification={showNotification}
            shouldHideMap={{}}
            isEditMode={true}
          />
          <Box mt={2}>
            <ButtonSection
              history={history}
              loading={submitting}
            />
          </Box>
        </form>
      </FormProvider>
      <SnackBar
        title='Update Successful'
        type='success'
        open={showSuccess}
        onClose={(e, reason) => {
          if (reason === 'timeout') {
            setShowSuccess(false)
            history.push(pathMap.UAE_MPCI_VESSEL_MASTER_LIST_VIEW)
          }
        }}
        duration={3000}
      >
        Vessel updated successfully. Redirecting...
      </SnackBar>
      <SnackBar
        title='Update Failed'
        type='error'
        open={Boolean(showError)}
        onClose={() => setShowError(null)}
        duration={8000}
      >
        {showError || 'Failed to update Vessel. Please try again.'}
      </SnackBar>
    </ParentCard>
  )
}

export default EditPage

function ButtonSection({ history, loading }) {
  const [confirmDialog, setConfirmDialog] = useState(false)

  return (
    <>
      <Grid container justify='space-between' spacing={3}>
        <Grid item xs='auto'>
          <CngButton
            color='secondary'
            disabled={loading}
            onClick={() => setConfirmDialog(true)}
            size='medium'
          >
            Discard
          </CngButton>
        </Grid>
        <Grid item xs='auto'>
          <CngButton
            color='primary'
            disabled={loading}
            type='submit'
            size='medium'
            shouldShowProgress={loading}
          >
            Update
          </CngButton>
        </Grid>
      </Grid>
      <ConfirmDialog
        isConfirmDialogOpen={confirmDialog}
        closeDialog={() => setConfirmDialog(false)}
        confirmDialog={() => history.push(pathMap.UAE_MPCI_VESSEL_MASTER_LIST_VIEW)}
        content="All progress in this session will be lost and can't be restored. Are you sure about this?"
        okMsg='Yes, discard'
        cancelMsg='Continue editing'
        title='Discard'
      />
    </>
  )
}
